// Blood pressure is entered as a pair, "120 / 80" (plan §5.7). Both or neither.
//
// Refusing a systolic that is not above the diastolic is the plan's proposal, waiting on
// the clinical lead (plan §13, C10; TODO(clinical-verify)). It is a separate function so
// the answer changes one call, not the pair rule.

import type { Result } from '../result.ts';
import { err, ok } from '../result.ts';

export type BloodPressureErrorCode = 'vitals.bp_incomplete' | 'vitals.bp_order';

export const BLOOD_PRESSURE_ERRORS: Record<BloodPressureErrorCode, string> = {
  'vitals.bp_incomplete': 'Enter both systolic and diastolic, or neither',
  'vitals.bp_order': 'Systolic must be higher than diastolic. Check the values',
};

export interface BloodPressure {
  readonly systolic: number;
  readonly diastolic: number;
}

/** Both values present, or both absent (`null`). */
export function checkBloodPressurePair(
  systolic: number | null,
  diastolic: number | null,
): Result<BloodPressure | null, 'vitals.bp_incomplete'> {
  if (systolic === null && diastolic === null) return ok(null);
  if (systolic === null || diastolic === null) return err('vitals.bp_incomplete');
  return ok({ systolic, diastolic });
}

export function checkBloodPressureOrder(
  pressure: BloodPressure,
): Result<BloodPressure, 'vitals.bp_order'> {
  return pressure.systolic > pressure.diastolic ? ok(pressure) : err('vitals.bp_order');
}
